<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" opacity="0.2" size="large" type="ball-spin-clockwise"
    class="la-ball-spin-clockwise la-dark la-3x" class="custom-spinner">
</ngx-spinner>
